import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'

import { JsonPipe, NgClass, NgIf } from '@angular/common'

import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

interface modelLoading {
  replierItem: boolean
  contract: boolean
  email: boolean
  download: boolean
  edit: boolean
  manager: boolean
  view: boolean
  remove: boolean
  cancelContract: boolean
}

@Component({
  selector: 'table-list-schedule-fleet',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressSpinner,
    NgClass,
  ],
  templateUrl: './table-list-schedule-fleet.component.html',
  styleUrl: './table-list-schedule-fleet.component.scss',
})
export class TableListScheduleFleetComponent implements OnInit, OnChanges {
  constructor() { }

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() spinLoad: modelLoading = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
    cancelContract: false,
    replierItem: false,
  }
  @Output() selectItem = new EventEmitter<any>()
  @Output() viewItem = new EventEmitter<any>()
  @Output() downloadItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() sendContract = new EventEmitter<any>()
  @Output() sendEmail = new EventEmitter<any>()
  @Output() cancelContract = new EventEmitter<any>()
  @Output() replierItem = new EventEmitter<any>()
  @Output() additionalOccurrenceItem = new EventEmitter<any>()
  @Output() sendToPurchases = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  formatTime(time: string) {
    if (time) {
      const arrTime = time.split(':')
      if (arrTime.length > 1) {
        return `${arrTime[0]}:${arrTime[1]}`
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  downloadItemEvent(item: any): void {
    this.downloadItem.emit(item)
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  sendContractEvent(item: any): void {
    this.sendContract.emit(item)
  }

  sendEmailEvent(item: any): void {
    this.sendEmail.emit(item)
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }

  replierItemEvent(item: any): void {
    this.replierItem.emit(item)
  }

  cancelContractEvent(item: any): void {
    this.cancelContract.emit(item)
  }

  additionalOccurrenceEvent(item: any): void {
    this.additionalOccurrenceItem.emit(item)
  }

  sendToPurchasesEvent(item: any): void {
    this.sendToPurchases.emit(item)
  }
}
